import React, { useEffect, useRef } from "react";
import EventoVisualizarController from "../../DefaultPage/Evento/controller/evento-visualizar.controller";
import If from "../../../../vendors/components/If";
import EventoCard from "../../../components/evento-card";
import AnexoCard from "../../../components/anexo/AnexoCard";
import { Card } from "primereact/card";
import EventoVisualizarHeader from "../../DefaultPage/Evento/components/EventoVisualizarHeader";
import Tabs from "../../../components/tabs";
import Contribuir from "../../DefaultPage/Evento/components/Contribuir";
import NormaDefinitiva from "../../DefaultPage/Evento/components/NormaDefinitiva";
import Degravacao from "../../DefaultPage/Evento/components/Degravacao";
import ContribuicaoPublicada from "../../DefaultPage/Evento/components/ContribuicaoPublicada";
import ModalLogin from "../../../components/modal-login";
import SessaoPresencial from "../../DefaultPage/Evento/components/SessaoPresencial";
import { useLocation } from "react-router-dom";
import DocumentosdoEvento from "../../DefaultPage/Evento/components/DocumentosdoEvento";
import EventoInformesPopup from "../../../components/evento-informes-popup";
import { isEventoInterno } from "../../../shared/utils/EventoInternoUtil";

export default function EventoVisualizar() {
  const controller = new EventoVisualizarController(true);
  const evento = controller.evento;

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    controller.init();
  }, []);

  const codPropostaNorma = evento.codPropostaNorma

  return (
    <>
      <EventoInformesPopup evento={evento} />
      <div
        className="evento-vis-wrapper"
        style={{ flexDirection: controller.isCardExpanded ? 'column' : undefined }}
      >
        <If condition={controller.show && !controller.isCardExpanded}>
          <div className="evento-vis-col-secundaria">
            <EventoCard
              evento={evento}
              tpReuniao={controller.tpReuniao}
              onHide={() => controller.handleShow()}
              isExpanded={controller.isCardExpanded}
              onExpandToggle={() => controller.toggleCardExpanded()}
            />
            <AnexoCard
              showDownload={true}
              handleDownload={(e: any) => {
                controller.downloadPropostaNorma(e);
              }}
              handleAllDownload={() => {
                controller.downloadTodosAnexos();
              }}
              lista={controller.lista}
              handleTabDocumentacao={(value: any) => {
                controller.handleTab(value);
                handleScrollToTop();
              }}
            />
          </div>
        </If>

        {/* Caso o card esteja expandido, ele ocupa toda a parte superior */}
        <If condition={controller.isCardExpanded}>
          <div className="w-full mb-3">
            <EventoCard
              evento={evento}
              tpReuniao={controller.tpReuniao}
              onHide={() => controller.handleShow()}
              isExpanded={controller.isCardExpanded}
              onExpandToggle={() => controller.toggleCardExpanded()}
            />
          </div>
        </If>

        <div
          className="evento-vis-col-primaria"
          style={{ width: (controller.show && !controller.isCardExpanded) ? "" : "100%" }}
        >
          {/* Renderiza o AnexoCard aqui na coluna primária caso o EventoCard esteja expandido */}
          <If condition={controller.isCardExpanded}>
            <div className="mb-4">
              <AnexoCard
                showDownload={true}
                handleDownload={(e: any) => {
                  controller.downloadPropostaNorma(e);
                }}
                handleAllDownload={() => {
                  controller.downloadTodosAnexos();
                }}
                lista={controller.lista}
                handleTabDocumentacao={(value: any) => {
                  controller.handleTab(value);
                  handleScrollToTop();
                }}
              />
            </div>
          </If>
          <Card
            className="card-no-spaces"
            style={{ marginTop: controller.isCardExpanded ? '0px' : '' }}
            header={() => (
              <EventoVisualizarHeader controller={controller} evento={evento} />
            )}
          >
            <If condition={controller.abaList.length > 0}>
              <Tabs
                onClick={(value: any) => controller.handleTab(value)}
                ativo={controller.tab}
                items={controller.abaList}
              />
            </If>

            <Contribuir controller={controller} isBlock={true} />
            <SessaoPresencial controller={controller} />
            <NormaDefinitiva controller={controller} />
            <Degravacao controller={controller} />
            <ContribuicaoPublicada
              rollBackUrl={`/public/evento/visualizar?tab=${controller.tab}`}
              controller={controller}
            />
            {codPropostaNorma && (
              <DocumentosdoEvento
                controller={controller}
                codPropostaNorma={codPropostaNorma}
              />
            )}
          </Card>
        </div>
      </div>
      <ModalLogin
        visible={controller.visibleLogin}
        onHide={() => controller.setVisibleLogin(false)}
        dispositivoLogin={controller.dispositivoLogin}
        isEventoInterno={isEventoInterno(evento)}
        onLoginSuccess={(d) => controller.navegarAposLoginInterno(d)}
      />
    </>
  );
}
